// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  AddTaskOutlined,
  Contrast,
  DoNotDisturbAltOutlined,
  EditOutlined,
  KeyboardTabOutlined,
  LocalShippingOutlined,
  PendingOutlined,
  SettingsEthernetOutlined,
} from '@/constants/hardfin-standard-icons';
import type {
  FulfillmentOrderPhase,
  FulfillmentOrderSubstatus,
} from '@/fulfillment/constants/fulfillment-order-status';
import { ReactElement } from 'react';

const FO_BASE_STATUS_ICONS: Record<FulfillmentOrderPhase, () => ReactElement> =
  {
    draft: () => <EditOutlined fontSize="small" />,
    awaiting_3pl: () => <SettingsEthernetOutlined fontSize="small" />,
    open: () => <PendingOutlined fontSize="small" />,
    shipped: () => <LocalShippingOutlined fontSize="small" />,
    delivered: () => <KeyboardTabOutlined fontSize="small" />,
    cancelled: () => <DoNotDisturbAltOutlined fontSize="small" />,
  };

/**
 * Get the appropriate icon for a fulfillment order status.
 * Partial and overage modifiers override the base icon.
 */
export function getStatusIcon(
  base: FulfillmentOrderPhase,
  modifier: FulfillmentOrderSubstatus | null
): ReactElement {
  if (modifier === 'partial') {
    return <Contrast fontSize="small" />;
  }
  if (modifier === 'overage') {
    return <AddTaskOutlined fontSize="small" />;
  }
  return FO_BASE_STATUS_ICONS[base]();
}
